<template>
  <Template>
    <NewsDetails />
  </Template>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Template from "@/components/Templates/Punalur.vue";
import NewsDetails from "@/components/NewsDetails/Template3/index.vue";
import { NEWS_DETAIL_PAGE_NAMES } from "@/ts/enum";

export default defineComponent({
  name: NEWS_DETAIL_PAGE_NAMES.POYANIL_HOSPITAL_PUNALUR,
  components: {
    NewsDetails,
    Template,
  },
});
</script>
